import styles from "./index.module.scss";

export default function AiBanner({ className = "", aiDisabled = false, onEnable }) {
  if (!aiDisabled) return null;

  return (
    <div className={`${styles.aiBanner} ${className}`}>
      <div className={styles.content}>
        AI assist is off for this session.
      </div>
      <button className={styles.enableButton} onClick={onEnable}>
        Enable
      </button>
    </div>
  );
}
